export default defineAppConfig({
  ui: {
    primary: 'emerald',
    gray: 'zinc',
    button: {
      color: {
        primary: {
          solid: 'shadow-sm text-action dark:text-action bg-action hover:bg-action/90 disabled:bg-action dark:bg-action dark:hover:bg-action dark:disabled:bg-action/70 focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-action dark:focus-visible:ring-action',
          link: 'text-gray-900 dark:text-white underline-offset-4 hover:underline focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400',
          soft: 'text-primary dark:text-action bg-action/20 hover:bg-action hover:text-action disabled:bg-action dark:bg-action dark:hover:bg-action dark:disabled:bg-action focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-action dark:focus-visible:ring-action',
        },
      }
    },
    carousel: {
      indicators: {
        active: 'bg-action',
        inactive: 'bg-secondary'
      }
    },
    card: {
      background: 'bg-white dark:bg-gray-800/50',
      body: {
        padding: 'p-3 sm:p-3'
      },
      header: {
        base: 'font-medium text-sm',
        padding: 'px-3 py-2 sm:px-3'
      }
    },
    table: {
      td: {
        color: 'text-gray-800 dark:text-gray-400'
      },
    },
    slideover: {
      wrapper: "fixed inset-2 flex z-50",
      width: "w-screen max-w-2xl",
      height: "h-full",
      base: "overflow-hidden rounded-lg shadow-lg",
      background: "bg-secondary",
      overlay: {
        background: "bg-primary/70",
      },
    },
    tabs: {
      list: {
        background: 'bg-primary',
        height: 'h-12',
        marker: {
          background: 'bg-action',
          rounded: 'rounded'
        },
        tab: {
          active: 'text-action',
          inactive: 'text-primary',
          rounded: 'rounded',
          height: 'h-10'
        }
      }
    },
    input: {
      rounded: 'rounded',
      color: {
        white: {
          outline: 'bg-secondary text-secondary dark:bg-secondary dark:text-secondary ring-1 ring-border dark:ring-border ring-inset focus:ring-2 focus:ring-action dark:focus:ring-action',
        },
      },
      variant: {
        outline: 'bg-transparent text-primary dark:text-primary ring-1 ring-inset ring-action focus:ring-2 focus:ring-action-500 dark:focus:ring-action-500',
      },
      icon: {
        base: 'text-secondary dark:text-secondary',
        color: 'text-primary dark:text-primary',
      }
    },
    inputMenu: {
      rounded: 'rounded',
      color: {
        white: {
          outline: 'bg-secondary text-secondary dark:bg-secondary dark:text-secondary ring-1 ring-border dark:ring-border ring-inset focus:ring-2 focus:ring-action dark:focus:ring-action',
        },
      },
      variant: {
        outline: 'bg-transparent text-primary dark:text-primary ring-1 ring-inset ring-action focus:ring-2 focus:ring-action-500 dark:focus:ring-action-500',
      }
    },
    textarea: {
      rounded: 'rounded',
      color: {
        white: {
          outline: 'bg-secondary text-secondary dark:bg-secondary dark:text-secondary ring-1 ring-border dark:ring-border ring-inset focus:ring-2 focus:ring-action dark:focus:ring-action',
        },
      },
      variant: {
        outline: 'bg-transparent text-primary dark:text-primary ring-1 ring-inset ring-action focus:ring-2 focus:ring-action-500 dark:focus:ring-action-500',
      }
    },
    select: {
      rounded: 'rounded',
      color: {
        white: {
          outline: 'bg-secondary text-secondary dark:bg-secondary dark:text-secondary ring-1 ring-border dark:ring-border ring-inset focus:ring-2 focus:ring-action dark:focus:ring-action',
        },
      },
      variant: {
        outline: 'bg-transparent text-primary dark:text-primary ring-1 ring-inset ring-action focus:ring-2 focus:ring-action-500 dark:focus:ring-action-500',
      }
    },
    toggle: {
      active: 'bg-action dark:bg-action',
      inactive: 'bg-secondary dark:bg-secondary',
      container: {
        base: 'bg-primary dark:bg-primary',
      }
    },
    checkbox: {
      default: {
        color: 'action',
      },
      background: 'bg-transparent',
      label: 'text-secondary',
      color: 'text-highlight dark:text-highlight',
      rounded: 'rounded-sm',
      border: 'border-[rgb(var(--bookapp-text-primary) / 1)] dark:border-[rgb(var(--bookapp-text-primary) / 1)]'
    },
    radio: {
      default: {
        color: 'action',
      },
      background: 'bg-transparent',
      label: 'text-secondary',
      color: 'text-highlight dark:text-highlight',
      // rounded: 'rounded-sm',
      border: 'border-[rgb(var(--bookapp-text-primary) / 1)] dark:border-[rgb(var(--bookapp-text-primary) / 1)]'
    },
    badge: {
      color: {
        primary: {
          solid: 'bg-action text-action',
          soft: 'text-primary dark:text-action bg-action/20 dark:bg-action dark:hover:bg-action dark:disabled:bg-action',
        }
      },
    },
    formGroup: {
      label: {
        base: 'text-secondary font-semibold'
      },
      description: 'text-secondary/80',
    }
  }
})
